import { render, staticRenderFns } from "./XomeMemory.vue?vue&type=template&id=4eeb827c&"
import script from "./XomeMemory.vue?vue&type=script&lang=js&"
export * from "./XomeMemory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports